export default "__VITE_ASSET__DLtqMYON__"